<template>
  <div
    class="tw-inline-flex tw-gap-1 tw-border tw-border-solid tw-items-center tw-rounded-full tw-justify-between tw-text-sm tw-leading-5 tw-px-3 tw-font-bold"
    :class="[variantClass, selectedClass, highlitedClass, sizeClass]"
  >
    <div
      class="tw-flex tw-justify-center tw-gap-1"
      :class="[cursorClass]"
      @click="onClick"
    >
      <slot name="prepend"></slot>
      <img
        v-if="isSelected && !selectedNoIcon"
        :src="negativeVariant ? MinusRed : SelectedCheck"
        alt=""
        class="tw-mr-1 tw-w-6 -tw-ml-2"
      />
      <div class="tw-my-1.5 tw-overflow-hidden tw-whitespace-nowrap">
        {{ value }}
      </div>
    </div>

    <div
      v-if="draggable"
      class="tw-text-xl tw-relative tw-w-6 tw-h-1 tw-cursor-move"
    >
      <div class="tw-absolute -tw-right-2 tw-top-0 -tw-mt-3.5 tw-w-6">
        <img :src="DragIcon" alt="" class="tw-w-full" />
      </div>
    </div>
    <div
      v-if="close"
      class="tw-text-xl tw-relative tw-w-4 tw-h-1 tw-cursor-pointer"
      :class="{ '!tw-cursor-default': readonly }"
      @mousedown.prevent="onClose"
    >
      <div
        class="tw-absolute tw-right-0 tw-top-1/2 -tw-translate-y-1/2 -tw-mr-1 tw-leading-0"
      >
        <img :src="CloseIcon" />
      </div>
    </div>
    <div
      v-if="editable"
      class="tw-text-xl tw-relative tw-w-6 tw-h-1 tw-cursor-pointer"
      @click="onEdit"
    >
      <div class="tw-absolute tw-right-0 tw-top-0 -tw-mt-3">
        <img :src="EditIcon" class="tw-w-4 tw-h-4" />
      </div>
    </div>
  </div>
</template>
<script>
import DragIcon from '@/assets/img/drag-svgrepo-com.svg';
import EditIcon from '@/assets/icons/edit-icon2.svg';
import CloseIcon from '@/assets/icons/close-small-icon.svg';
import SelectedCheck from '@/assets/icons/selected-check.svg';
import MinusRed from '@/assets/icons/minus-red-icon.svg';

export default {
  props: {
    variant: {
      type: String,
      default: 'fill',
    },

    value: {
      type: [String],
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    isSelected: {
      type: Boolean,
      default: false,
    },

    close: {
      type: Boolean,
      default: false,
    },

    draggable: {
      type: Boolean,
      default: false,
    },

    draggableCursor: {
      type: Boolean,
      default: false,
    },

    highlited: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },

    selectedNoIcon: {
      type: Boolean,
      default: false,
    },

    editable: {
      type: Boolean,
      default: false,
    },

    readonly: Boolean,

    negativeVariant: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      SelectedCheck,
      MinusRed,
      DragIcon,
      EditIcon,
      CloseIcon,
    };
  },

  computed: {
    selectedClass() {
      if (this.selectedNoIcon) {
        if (this.negativeVariant) {
          return this.isSelected
            ? 'tw-border-red-600 !tw-bg-red-100 hover:tw-bg-red-200'
            : '';
        }
        return this.isSelected
          ? 'tw-border-purple-600 !tw-bg-purple-100 hover:tw-bg-purple-200'
          : '';
      }

      if (this.negativeVariant) {
        return this.isSelected
          ? 'tw-border-red-600 !tw-bg-red-100 hover:tw-bg-red-200'
          : '';
      }

      return this.isSelected
        ? 'tw-border-purple-600 tw-bg-purple-100 hover:tw-bg-purple-200'
        : '';
    },

    cursorClass() {
      if (this.readonly) return '';
      if (this.draggable || this.draggableCursor)
        return 'tw-cursor-move tw-select-none';
      return 'tw-cursor-pointer';
    },

    highlitedClass() {
      if (this.highlited) {
        return this.negativeVariant
          ? 'tw-border-red-600'
          : 'tw-border-purple-600';
      }
      return '';
    },

    variantClass() {
      let result = '';
      switch (this.variant) {
        case 'outlined':
          result = 'tw-border-purple-600 !tw-text-purple-600';
          if (this.disabled) result += ' tw-opacity-30  !tw-cursor-default';
          else
            result +=
              ' hover:tw-bg-purple-100 active:tw-border-purple-900 active:tw-text-purple-900';
          break;

        case 'outlined-1':
          result = 'tw-border-gray-400 tw-bg-white';
          if (this.disabled)
            result = 'tw-border-gray-300 !tw-text-gray-400 tw-bg-white';
          if (this.disabled || this.draggableCursor) {
            result +=
              ' hover:tw-bg-gray-100 active:tw-border-gray-400 active:tw-bg-white active:tw-shadow-btn';
          }
          if (this.clickable) {
            result +=
              ' hover:tw-bg-purple-100 active:tw-border-gray-400 active:tw-shadow-btn';
          }
          break;

        case 'dark':
          result = 'tw-bg-gray-900 tw-text-white tw-cursor-default';
          break;

        default:
          result =
            'tw-bg-gray-300 tw-border-gray-300 hover:tw-bg-gray-400 active:tw-border-gray-400 active:tw-bg-white active:tw-shadow-btn';
          if (this.disabled)
            result = 'tw-border-gray-100 !tw-text-gray-400 tw-bg-white';
          break;
      }
      return result;
    },

    sizeClass() {
      let result = '';
      if (this.small) {
        result = 'tw-h-8';
      } else {
        result = '';
      }
      return result;
    },
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    onClick() {
      this.$emit('click');
    },

    onEdit() {
      this.$emit('edit');
    },
  },
};
</script>
